module.exports = __webpack_public_path__ + "img/lev1.a8042633.png";